import React, { useState } from 'react'
import Sidebar from '../../Common/Sidebar/Sidebar';
import '../globalStyle.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from "react-toastify";
import axios from 'axios';

export default function AddProbondho() {
    const [probondhoInfo, setProbondhoInfo] = useState({});

    const saveProbondho = async (e) => {
        e.preventDefault();
        try {
          if(probondhoInfo.description.length > 0){
            const probondhoInserted = await axios.post(
              `https://ahlehaqserver.herokuapp.com/api/probondho`,
              probondhoInfo
            );
    
            //if request success, will show success notification
            if (probondhoInserted.data.code === 200) {
              setProbondhoInfo({});
              toast.success("Probondho added successfully!");
              e.target.reset();
            }
          }else{
            toast("Please write description")
          }

        } catch (error) {
          console.log(error);
          toast.error("Internal Server Error!");
        }
      };
    return (
        <div>

        <div className="row">
           <div className="col-md-3">
               <Sidebar/>
           </div>
           <div className="col-md-9">
             <h1 className="ml-3">Add a probondho</h1>

             <form onSubmit={saveProbondho}>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Probondho Title<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="write probondho title"
                              id="exampleInputPassword1"
                              name="title"
                              value={probondhoInfo?.title || ""}
                              required
                              onChange={(e) =>
                                setProbondhoInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                         <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Probondho Short Description<span className="text-danger">*</span>
                            </label>
                            <textarea
                              type="text"
                              rows="5"
                              className="form-control"
                              placeholder="write probondho short description"
                              id="exampleInputPassword1"
                              name="shortDetails"
                              value={probondhoInfo?.shortDetails || ""}
                              required
                              onChange={(e) =>
                                setProbondhoInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>
                          
                         <div className="col-md-12">
                         <label for="exampleInputEmail1" className="font-weight-bold">
                                Write Description<span className="text-danger">*</span>
                              </label>
                            <CKEditor
                                editor={ ClassicEditor }
                                data={probondhoInfo?.description || ""}
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setProbondhoInfo((Prev) => ({ ...Prev, description: data }))
                           
                                } }
                            />
                         </div>  
                          
                         <div className="col-md-4">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                            </div>  
                         </div> 

                      </div>

                      
                    </form>
           </div>
        </div> 
       </div>
    )
}
